import React, { FC } from 'react';
import Attachments from './Attachments';
import Content from './Content';
import { Message } from '../../../../../interfaces/Message';
import { StyledDivider } from '../AnswerMail/AnswerMail.styles';
import { StyledDivBottom } from '../Details.styles';

export interface MailContentProps {
  message: Message;
}
const MailContent: FC<MailContentProps> = ({ message }) => (
  <>
    <Content message={message} />
    <StyledDivBottom>
      <Attachments attachments={message?.attachments} />
    </StyledDivBottom>
    <StyledDivider />
  </>
);

export default MailContent;
